import React from 'react';
import useFinancialScope, { scopeIsNarrowing } from './useFinancialScope';

/**
 * The "nothing to show" block on a Financials list.
 *
 * "No Invoices Yet" is a claim about the world, and when the list has been
 * narrowed to one entity it is a false one — there may be a hundred invoices,
 * all belonging to a sibling company. That headline sitting under a banner
 * explaining the narrowing is the same fault the banner exists to fix, only in
 * the largest text on the screen.
 *
 * So when a scope is in force the heading says whose book is empty. When it is
 * not, the original wording stands: for an unscoped reader "none yet" really is
 * the whole truth.
 *
 * Props:
 *   label   — plural noun for these documents ("invoices", "credit notes")
 *   heading — the original unscoped heading ("No Invoices Yet")
 *   blurb   — the original unscoped subtitle
 */
const FinancialsEmptyState = ({ label, heading, blurb }) => {
  const scope = useFinancialScope();
  const narrowed = scopeIsNarrowing(scope);

  return (
    <div className="empty-state-text">
      <h3>{narrowed ? `No ${label} for ${scope.entityName}` : heading}</h3>
      <p>
        {narrowed
          ? `Other IMT entities may have ${label} you cannot see from here.`
          : blurb}
      </p>
    </div>
  );
};

export default FinancialsEmptyState;
